import {
  AccessTime,
  Image,
  InsertDriveFile,
  LibraryBooks,
  Message,
  MicNone,
  Videocam,
} from "@mui/icons-material";
import React, { memo } from "react";
import { NodeCard, mutedText } from "./commonNode";

const accent = "#ef5350";

const getElement = (data, item) =>
  data?.elements?.find((element) => element.number === item) || {};

const getContentMeta = (data, item) => {
  const element = getElement(data, item);

  if (item.includes("message")) {
    return { icon: <Message />, label: element.value || "Mensagem" };
  }

  if (item.includes("interval")) {
    return { icon: <AccessTime />, label: `${element.value || 0} segundos` };
  }

  if (item.includes("img")) {
    return { icon: <Image />, label: element.original || "Imagem" };
  }

  if (item.includes("audio")) {
    return { icon: <MicNone />, label: element.original || "Audio" };
  }

  if (item.includes("video")) {
    return { icon: <Videocam />, label: element.original || "Video" };
  }

  return { icon: <InsertDriveFile />, label: element.original || "Documento" };
};

export default memo(({ data, isConnectable, id }) => {
  const sequence = Array.isArray(data?.seq) ? data.seq : [];

  return (
    <NodeCard
      id={id}
      title="Conteúdo"
      accent={accent}
      icon={<LibraryBooks sx={{ width: 15, height: 15, color: accent }} />}
      isConnectable={isConnectable}
      width={220}
      targetTop="50%"
      sourceHandles={[{ id: "a", top: "88%" }]}
    >
      <div style={{ display: "grid", gap: 7 }}>
        {sequence.length === 0 && (
          <div style={mutedText}>Nenhum conteúdo configurado</div>
        )}

        {sequence.map((item) => {
          const meta = getContentMeta(data, item);

          return (
            <div
              key={item}
              style={{
                display: "grid",
                gridTemplateColumns: "22px minmax(0, 1fr)",
                alignItems: "center",
                gap: 8,
                minHeight: 34,
                borderRadius: 6,
                background: `${accent}10`,
                padding: "7px 9px"
              }}
            >
              {React.cloneElement(meta.icon, {
                sx: { width: 16, height: 16, color: accent }
              })}
              <span
                style={{
                  color: "#374151",
                  fontSize: 11,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap"
                }}
              >
                {meta.label}
              </span>
            </div>
          );
        })}
      </div>
    </NodeCard>
  );
});
